<template>
  <el-container class="user-container">
    <el-header>
      <el-button style="margin-top: 20px" icon="el-icon-arrow-left" plain @click="back">返回</el-button>
    </el-header>
    <el-main class="user-main">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <el-button type="primary" icon="el-icon-star-off" round></el-button>
        </div>
        <el-row class="user-item">
          <span>用户名：</span><span>{{ this.$data.userName }}</span>
        </el-row>
        <el-divider></el-divider>
        <el-row class="user-item">
          <span>到期时间：</span><span>{{ this.$data.expiredTime }}</span>
        </el-row>
        <el-divider></el-divider>
        <el-row class="user-item" v-if="accountEnabled === 1">
          <div>学习账号：<span>{{ this.$data.account }}</span></div>
          <el-button style="margin-top: 10px" @click="unbindAccount">解绑</el-button>
        </el-row>
        <el-row v-if="accountEnabled === 0 || accountEnabled === null">
          <el-button type="primary" @click="bindAccount">绑定</el-button>
          <div style="margin-top: 10px">首次绑定学习账号送三天使用时间</div>
        </el-row>
      </el-card>
      <el-dialog title="绑定学习账号" :visible.sync="bindVisible" center>
        <el-form :model="studyForm" :rules="rules" ref="studyForm">
          <el-form-item prop="type">
            <el-select v-model="studyForm.type" placeholder="选择账号类型" style="margin: auto; display:block;">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="studyForm.type==='3'" prop="code">
            <el-input v-model="studyForm.code" placeholder="企业id"></el-input>
          </el-form-item>
          <el-form-item prop="account">
            <el-input v-model="studyForm.account" placeholder="请输入学习账号"></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input v-model="studyForm.password" placeholder="请输入密码" show-password></el-input>
          </el-form-item>
        </el-form>
        <div style="margin-top: 10px">注：绑定成功后会自动获得三天使用时间（仅限首次绑定）</div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="bindVisible = false">取 消</el-button>
            <el-button type="primary" @click="verify" v-loading="verifing">开始验证</el-button>
          </span>
      </el-dialog>
    </el-main>
  </el-container>
</template>

<script>
export default {
  name: 'UserInfo',
  data () {
    return {
      userName: '',
      expiredTime: '',
      account: '',
      accountEnabled: 0,
      bindVisible: false,
      verifing: false,
      options: [{
        value: '1',
        label: '超星云课堂'
      }, {
        value: '2',
        label: '择优网校'
      }, {
        value: '3',
        label: '云端学习'
      }, {
        value: '4',
        label: '金融之家'
      }],
      studyForm: {
        account: '',
        password: '',
        code: '',
        type: ''
      },
      rules: {
        type: [
          { required: true, message: '请选择账号类型', trigger: 'change' }
        ],
        code: [
          { required: true, message: '请输入企业id', trigger: 'change' }
        ],
        account: [
          { required: true, message: '请输入学习账号', trigger: 'change' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'change' }
        ]
      }
    }
  },
  created: function () {
    this.getUserInfo()
  },
  methods: {
    back () {
      this.$router.go(-1)
    },
    getUserInfo () {
      this.$axios.get('/user/getUserInfo').then(res => {
        if (res.data['status'] === 200) {
          this.$data.userName = res.data['data']['account']
          this.$data.expiredTime = res.data['data']['expiredTime']
          this.$data.account = res.data['data']['csAccount']
          this.$data.accountEnabled = res.data['data']['csEnabled']
        }
      })
    },
    bindAccount () {
      this.$data.bindVisible = true
    },
    unbindAccount () {
      this.$axios.post('/user/unbindStudyAccount').then(res => {
        if (res.data['status'] === 200) {
          this.$data.accountEnabled = 0
          this.$message({
            message: '解绑成功！',
            type: 'success'
          })
        } else {
          this.$message.error('解绑失败!')
        }
      }).catch(e => {
        this.$message.error('解绑出现异常！')
      })
    },
    verify () {
      var isValid = true
      this.$refs['studyForm'].validate((valid) => {
        isValid = valid
      })

      if (!isValid) {
        console.log('error submit!!')
        return false
      }

      var postData = {type: this.$data.studyForm.type, code: this.$data.studyForm.code, account: this.$data.studyForm.account, password: this.$data.studyForm.password}
      this.$data.verifing = true
      this.$axios.post('/user/bindStudyAccount', this.$qs.stringify(postData)).then(res => {
        this.$data.verifing = false
        if (res.data['status'] === 200) {
          this.$data.bindVisible = false
          this.$message({
            message: '验证成功！',
            type: 'success'
          })

          this.getUserInfo()
        } else {
          this.$message.error(res.data['message'])
        }
      }).catch(e => {
        this.$data.verifing = false
        this.$message.error('验证出现异常！')
      })
    }
  }
}
</script>

<style>
  .user-container {
    flex-direction: column;
  }
  .user-main {
    margin: auto;
    text-align: center;
  }
  .user-item {
    font-size: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/UserInfo.vue